(() => {
  const header = document.querySelector('[data-marturi-header]');
  if (!header) return;
  const menu = header.querySelector('details');
  const trigger = menu.querySelector('summary');
  header.querySelectorAll('nav a').forEach(link => {
    const target = new URL(link.href);
    if (target.pathname === location.pathname && target.search === location.search) link.setAttribute('aria-current', 'page');
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu.open) { menu.open = false; trigger.focus(); }
  });
  document.addEventListener('click', event => {
    if (event.target instanceof Node && !header.contains(event.target)) menu.open = false;
  });
  header.addEventListener('focusout', () => {
    requestAnimationFrame(() => { if (!header.contains(document.activeElement)) menu.open = false; });
  });
  matchMedia('(min-width:900px)').addEventListener('change', event => { if (event.matches) menu.open = false; });
})();

// Cart-only enhancement: native drawer code continues to own opening and closing.
(() => {
  if (window.marturiCartFocusInitialized) return;
  window.marturiCartFocusInitialized = true;
  let session = null;
  let pendingOpener = null;
  const focusableSelector = 'a[href],button,input,select,textarea,[tabindex],summary';
  function visible(element) {
    if (!element || !element.isConnected || element.closest('[hidden],[inert],[aria-hidden="true"]')) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }
  function controls(cart) {
    return Array.from(cart.querySelectorAll(focusableSelector)).filter(element =>
      element.tabIndex >= 0 && !element.matches(':disabled,[aria-disabled="true"]') && visible(element));
  }
  function otherDialog(cart) {
    return Array.from(document.querySelectorAll('.t4s-drawer[aria-hidden="false"],[role="dialog"][aria-modal="true"],dialog[open]'))
      .some(element => element !== cart && !cart.contains(element) && visible(element));
  }
  function focusEntry(cart) {
    const options = controls(cart);
    const close = cart.querySelector('[data-drawer-close]');
    (options.includes(close) ? close : options[0] || cart).focus({preventScroll:true});
  }
  function restoreAttributes(current) {
    for (const [name,value] of Object.entries(current.attributes)) {
      if (value === null) current.cart.removeAttribute(name);
      else current.cart.setAttribute(name,value);
    }
  }
  function sync() {
    const cart = document.querySelector('#t4s-mini_cart');
    const open = cart && cart.getAttribute('aria-hidden') === 'false' && visible(cart);
    if (session && (!open || session.cart !== cart)) {
      const previous = session;
      session = null;
      restoreAttributes(previous);
      if (!open && !otherDialog(previous.cart) && visible(previous.opener)) previous.opener.focus({preventScroll:true});
      pendingOpener = open ? previous.opener : null;
    }
    if (!open) return;
    if (!session) {
      const attributes = {};
      ['role','aria-modal','aria-label','tabindex'].forEach(name => attributes[name] = cart.getAttribute(name));
      session = {cart,opener:pendingOpener || document.activeElement,attributes};
      pendingOpener = null;
      cart.setAttribute('role','dialog');
      cart.setAttribute('aria-modal','true');
      const title = cart.querySelector('.t4s-drawer__header .t4s_as_title');
      if (!cart.getAttribute('aria-label') && title) cart.setAttribute('aria-label',title.textContent.trim());
      cart.setAttribute('tabindex','-1');
    }
    if (!otherDialog(cart) && !cart.contains(document.activeElement)) focusEntry(cart);
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest && event.target.closest('[data-drawer-options]');
    if (!trigger || session) return;
    try {
      if (JSON.parse(trigger.getAttribute('data-drawer-options')).id === '#t4s-mini_cart') pendingOpener = trigger;
    } catch (_) { /* Leave malformed/native fallback links untouched. */ }
  },true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    sync();
    if (!session || otherDialog(session.cart)) return;
    const options = controls(session.cart);
    const index = options.indexOf(document.activeElement);
    const next = index < 0 ? (event.shiftKey ? options.length - 1 : 0)
      : (index + (event.shiftKey ? -1 : 1) + options.length) % options.length;
    event.preventDefault();
    event.stopImmediatePropagation();
    (options[next] || session.cart).focus({preventScroll:true});
  },true);
  document.addEventListener('focusin', () => {
    if (session && !session.cart.contains(document.activeElement)) sync();
  },true);
  // Lazy drawer markup can precede its stylesheet; visibility then changes without a DOM mutation.
  document.addEventListener('load', event => {
    if (event.target.tagName !== 'LINK') return;
    const cart = document.querySelector('#t4s-mini_cart');
    if (cart && cart.getAttribute('aria-hidden') === 'false') sync();
  },true);
  document.addEventListener('transitionend', event => {
    const cart = document.querySelector('#t4s-mini_cart');
    if (cart && event.target === cart && cart.getAttribute('aria-hidden') === 'false') sync();
  });
  function init() {
    new MutationObserver(sync).observe(document.documentElement, {
      subtree:true,childList:true,attributes:true,attributeFilter:['aria-hidden']
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

// Progressive disclosure for cart shipping conditions; original policy links remain fallbacks.
(() => {
  if (window.marturiCartConditionsInitialized) return;
  window.marturiCartConditionsInitialized = true;
  const shippingSelector = ':is(#t4s-mini_cart,.t4s-cartPage__form) :is(.t4s-cart__thres1,.t4s-cart__thres2,.t4s-cart__thres3) a[href="/policies/shipping-policy"]';
  const returnsSelector = ':is(#t4s-mini_cart,.t4s-cartPage__form) a[data-marturi-cart-returns][href="/policies/refund-policy"]';
  const triggerSelector = shippingSelector + ',' + returnsSelector;
  let dialog = null;
  let session = null;
  let escapeReleasePending = false;
  function visible(element) {
    if (!element || !element.isConnected || element.closest('[hidden],[inert],[aria-hidden="true"]')) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }
  function createDialog() {
    if (dialog) return dialog;
    const candidate = document.createElement('dialog');
    if (typeof candidate.showModal !== 'function') return null;
    candidate.id = 'mt-cart-shipping-dialog';
    candidate.className = 'mt-cart-shipping-dialog';
    candidate.setAttribute('aria-labelledby','mt-cart-shipping-title');
    candidate.innerHTML = '<div class="mt-cart-shipping-dialog__header"><h2 id="mt-cart-shipping-title">Envíos en Colombia</h2><button type="button" data-mt-shipping-close>Cerrar</button></div>' +
      '<p><strong>Envío estándar $13.000 COP.</strong> Gratis desde $120.000 COP en zonas habilitadas.</p>' +
      '<p>Algunos departamentos tienen tarifas diferentes. El costo final se confirma con tu dirección al pagar.</p>' +
      '<a href="/policies/shipping-policy" target="_blank" rel="noopener noreferrer" aria-label="Leer política de envío completa (abre otra pestaña)">Leer política completa</a>';
    const style = document.createElement('style');
    style.textContent = '.mt-cart-shipping-dialog{box-sizing:border-box;width:min(420px,calc(100vw - 32px));max-height:calc(100dvh - 32px);overflow:auto;margin:auto;padding:20px;border:0;border-radius:16px;background:#fff;color:#242823;font-family:inherit;box-shadow:0 18px 50px rgba(20,26,19,.22)}.mt-cart-shipping-dialog::backdrop{background:rgba(18,25,18,.52)}.mt-cart-shipping-dialog__header{display:flex;align-items:start;justify-content:space-between;gap:12px;margin-bottom:12px}.mt-cart-shipping-dialog h2{margin:0;color:inherit;font-size:20px;font-weight:700;line-height:1.2}.mt-cart-shipping-dialog button{flex:none;min-width:44px;min-height:44px;padding:0 10px;border:1px solid #d4d7cf;border-radius:9px;background:#fff;color:#242823;font-family:inherit;font-size:13px;font-weight:600;line-height:1;cursor:pointer}.mt-cart-shipping-dialog p{margin:0 0 10px;font-size:16px;line-height:1.5}.mt-cart-shipping-dialog a{display:inline-flex;align-items:center;min-height:44px;margin-top:6px;color:#384915;font-size:14px;font-weight:700;text-decoration:underline;text-underline-offset:3px}.mt-cart-shipping-dialog :is(button,a):focus-visible{outline:2px solid #52621e;outline-offset:2px}';
    document.head.append(style);
    document.body.append(candidate);
    dialog = candidate;
    dialog.querySelector('[data-mt-shipping-close]').addEventListener('click',() => dialog.close());
    dialog.addEventListener('close',() => {
      const previous = session;
      session = null;
      if (!previous) return;
      previous.observer?.disconnect();
      const cartOpen = previous.cart && visible(previous.cart) && previous.cart.getAttribute('aria-hidden') === 'false';
      if (cartOpen && previous.cartModal !== null) previous.cart.setAttribute('aria-modal',previous.cartModal);
      let target = visible(previous.trigger) ? previous.trigger : null;
      if (!target && cartOpen) target = previous.cart.querySelector(previous.selector) || previous.cart.querySelector('[data-drawer-close]');
      if (!target && !previous.cart) target = Array.from(document.querySelectorAll(previous.selector)).find(visible);
      if (visible(target)) target.focus({preventScroll:true});
    });
    return dialog;
  }
  function setSummary(modal, isReturns) {
    modal.querySelector('h2').textContent = isReturns ? 'Cambios y devoluciones' : 'Envíos en Colombia';
    const paragraphs = modal.querySelectorAll('p');
    paragraphs[0].innerHTML = isReturns
      ? 'Puedes solicitar un cambio o devolución si el producto cumple las condiciones de la política.'
      : '<strong>Envío estándar $13.000 COP.</strong> Gratis desde $120.000 COP en zonas habilitadas.';
    paragraphs[1].textContent = isReturns
      ? 'Los productos de cuidado personal abiertos o con el sello roto pueden estar excluidos. Revisa los plazos y requisitos antes de solicitarlo.'
      : 'Algunos departamentos tienen tarifas diferentes. El costo final se confirma con tu dirección al pagar.';
    const fullPolicy = modal.querySelector('a');
    fullPolicy.setAttribute('href', isReturns ? '/policies/refund-policy' : '/policies/shipping-policy');
    fullPolicy.setAttribute('aria-label', isReturns ? 'Leer política de devoluciones completa (abre otra pestaña)' : 'Leer política de envío completa (abre otra pestaña)');
  }
  document.addEventListener('click',event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest && event.target.closest(triggerSelector);
    if (!trigger || !visible(trigger)) return;
    const cart = trigger.closest('#t4s-mini_cart');
    const blocked = Array.from(document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"],.t4s-drawer[aria-hidden="false"]'))
      .some(element => element !== cart && element !== dialog && visible(element));
    if (blocked) return;
    const modal = createDialog();
    if (!modal || modal.open) return;
    const isReturns = trigger.hasAttribute('data-marturi-cart-returns');
    setSummary(modal,isReturns);
    try { modal.showModal(); } catch (_) { return; }
    event.preventDefault();
    session = {trigger,cart,selector:isReturns ? returnsSelector : shippingSelector,cartModal:cart?.getAttribute('aria-modal') ?? null,observer:null};
    if (cart) {
      cart.removeAttribute('aria-modal');
      session.observer = new MutationObserver(() => {
        if (!cart.isConnected || cart.getAttribute('aria-hidden') !== 'false') modal.close();
      });
      session.observer.observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-hidden']});
    }
    modal.querySelector('[data-mt-shipping-close]').focus({preventScroll:true});
  });
  // Capture keeps Escape inside this summary instead of also closing the native cart drawer.
  document.addEventListener('keydown',event => {
    if (event.key === 'Escape' && escapeReleasePending && event.repeat) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (event.key === 'Escape' && !dialog?.open) escapeReleasePending = false;
    if (!dialog?.open || !session) return;
    if (event.key === 'Escape') {
      escapeReleasePending = true;
      event.preventDefault();
      event.stopImmediatePropagation();
      dialog.close();
    } else if (event.key === 'Tab') {
      const options = Array.from(dialog.querySelectorAll('button,a[href]')).filter(visible);
      const index = options.indexOf(document.activeElement);
      const next = index < 0 ? (event.shiftKey ? options.length - 1 : 0)
        : (index + (event.shiftKey ? -1 : 1) + options.length) % options.length;
      event.preventDefault();
      event.stopImmediatePropagation();
      (options[next] || dialog).focus({preventScroll:true});
    }
  },true);
  // Native Kalles closes drawers on keyup, after this summary has already closed on keydown.
  document.addEventListener('keyup',event => {
    if (event.key !== 'Escape' || !escapeReleasePending) return;
    escapeReleasePending = false;
    event.preventDefault();
    event.stopImmediatePropagation();
  },true);
  window.addEventListener('blur',() => { escapeReleasePending = false; });
})();
